import { GoToAccountSettingsCTA } from "./ctas";
export var WhatIsEoriIA = function WhatIsEoriIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_IS_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var WHAT_IS_EORI = function WHAT_IS_EORI(strictLocalize) {
  return strictLocalize({
    id: "J4Rz7Z",
    defaultMessage: [{
      "type": 0,
      "value": "Qu'est-ce qu'un numéro EORI ?"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "VAG9Vi",
    defaultMessage: [{
      "type": 0,
      "value": "Le numéro d'enregistrement et d'identification des opérateurs économiques (EORI) est un numéro unique utilisé par les entreprises pour s'identifier auprès des autorités douanières sur les déclarations de douane et autres documents d'importation. Avoir un numéro EORI permet d'éviter les retards potentiels et les frais de stockage si votre commande ne peut pas être traitée par les douanes dans les délais impartis. Nous vous recommandons donc d'obtenir un numéro EORI si vous importez des marchandises d'un autre pays. Vous pouvez saisir votre numéro EORI dans la section « Informations sur les taxes et les droits d'importation » de l'onglet « Mon profil » sur la page « Paramètres du compte »."
    }]
  });
};